import { gql } from 'graphql-request'

export const GET_LEVELS_SPECTATORS = gql`
  query GET_LEVELS_SPECTATORS($take: Int, $skip: Int) {
    getLevelsSpectators(take: $take, skip: $skip) {
      error
      status
      data {
        id
        emblem
        gradientColor
        level
        requiredExp
      }
    }
  }
`

export const GET_LEVELS_HOST = gql`
  query GET_LEVELS_HOST($take: Int, $skip: Int) {
    getLevelsHosts(take: $take, skip: $skip) {
      error
      status
      data {
        id
        emblem
        gradientColor
        level
        requiredExp
      }
    }
  }
`

export const GET_USER_LEVEL_FIRST = gql`
  query GET_USER_LEVEL_FIRST($userId: Int!) {
    getUserLevelFirst(userId: $userId) {
      data {
        user {
          id
          username
          imgUser
        }
        levelHostId
        levelSpectatorId
        levelSpectator {
          gradientColor
          emblem
          level
        }
        levelHost {
          gradientColor
          emblem
          level
        }
      }
    }
  }
`

export const GET_USER_LEVEL_ONE_BY_USER_ID = gql`
  query GET_USER_LEVEL_ONE_BY_USER_ID($userId: Int!) {
    getUserLevelOneByUserId(userId: $userId) {
      error
      status
      data {
        beforeLevelHostExperience
        beforeLevelSpectatorExperience
        levelHostExperience
        levelHostId
        levelSpectatorExperience
        levelSpectatorId
        nextLevelHostExperience
        nextLevelSpectatorExperience
        progressBarLevelHostExperience
        progressBarLevelSpectatorExperience
        userImgUser
        widthBarLevelHostExperience
        widthBarLevelSpectatorExperience
        userId
      }
    }
  }
`
